import { render, staticRenderFns } from "./FormSelect.vue?vue&type=template&id=140e1909&scoped=true&"
import script from "./FormSelect.ts?vue&type=script&lang=ts&"
export * from "./FormSelect.ts?vue&type=script&lang=ts&"
import style0 from "./FormSelect.scss?vue&type=style&index=0&id=140e1909&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140e1909",
  null
  
)

export default component.exports